import * as React from 'react';
import type { ReactElement, ReactNode } from 'react';

import type { ForgeDoc } from '@helpcenter/forge-ui-utils';

interface Props {
    forgeDoc: ForgeDoc;
    render: (forgeDoc: ForgeDoc) => ReactNode;
}

const TopLevelComponent = ({ forgeDoc, render }: Props): ReactElement => <>{forgeDoc.children.map(render)}</>;

export default TopLevelComponent;
